<app-stepper-form
  header="Officer Name Change"
  subheader="Form 484A2"
  formIcon="ic-change-officer-name-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="484 A2"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.CompanyMemberName"
      [hidden]="currentStep !== StepsEnum.CompanyMemberName"
    >
      <h1 class="h1-heading">{{ steps[currentStep].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Change"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <div class="form-group">
        <app-select
          label="Which Officeholder/Shareholder is the name change applicable to?"
          formControlName="selectedOfficerId"
          [options]="officersChangeNameOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div
        formGroupName="fullName"
        [hidden]="isCorporateSecurityHolder() || !form.controls.selectedOfficerId.value"
      >
        <h3 class="h3-heading">New Name</h3>

        <div class="form-group">
          <app-input
            label="First Name"
            formControlName="firstName"
            [customErrors]="directorFirstNameValidatorMsg"
          />
        </div>

        <div class="form-group">
          <app-input
            label="First Middle Name"
            formControlName="middleName1"
            [customErrors]="directorFirstNameValidatorMsg"
          />
        </div>

        <div class="form-group">
          <app-input
            label="Second Middle Name"
            formControlName="middleName2"
            [customErrors]="directorFirstNameValidatorMsg"
          />
        </div>

        <div class="form-group">
          <app-input
            label="Last Name"
            formControlName="lastName"
            [customErrors]="directorFirstNameValidatorMsg"
          />
        </div>
      </div>

      <div [hidden]="!isCorporateSecurityHolder() || !form.controls.selectedOfficerId.value">
        <div class="form-group">
          <app-input
            label="New Company Name"
            formControlName="companyName"
          />
        </div>
      </div>
    </section>
  </div>
</app-stepper-form>
